import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { I18nService } from '@app/shared/services/i18n/i18n.service';
import { NavigateService } from '@app/shared/services/navigate/navigate.service';
import { I18n } from '@app/i18n/strings-keys';
import { get } from 'lodash';
import { lazyInject } from '../../decorators';
import { PermissionService } from '../../services/permission/permission.service';

@Injectable()
export class PermissionGuard {
  @lazyInject(PermissionService)
  public permissionService: PermissionService;
  @lazyInject(I18nService) public i18nService: I18nService;
  @lazyInject(NavigateService) public navigateService: NavigateService;

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await this.permissionService.getUserPermissions();
    const routePermissions = get(
      route,
      'data.requiredPermissions',
      this.getDefaultPermissions(route),
    );
    const permissionOR = get(route, 'data.permissionOR', false);

    const errorMessage = get(
      route,
      'data.errorMessage',
      I18n.CommonErrors.NoPermitted,
    );

    if (
      this.permissionService.hasPermissionsSync(routePermissions, permissionOR)
    ) {
      return true;
    }

    this.navigateService.navigateToError(errorMessage);

    return false;
  }

  protected getDefaultPermissions(route: ActivatedRouteSnapshot): string[] {
    const entityType = get(route, 'data.ENTITY_TYPE');
    const defaultPermissions = entityType ? [`${entityType}.View`] : [];

    // const entityConfig = get({}, 'config', null);
    // const configPath: string = get(route, 'url[0].path') ? 'editor' : 'list';

    return defaultPermissions;
  }
}
